<template>
  <div>
    <v-row align="start" dense>
      <v-col
        cols="12"
        :sm="showOpenHelp === true ? '6' : '12'"
        v-if="
          getValueObject &&
            getValueObject.action !== undefined &&
            getValueObject.action.type === 'router'
        "
      >
        <v-btn
          :block="showOpenHelp"
          :to="{ name: getValueObject.action.value }"
        >
          <v-icon small left>fa-external-link-alt</v-icon>Aller à
        </v-btn>
      </v-col>
      <v-col
        cols="12"
        :sm="showOpenHelp === true ? '6' : '12'"
        v-if="
          getValueObject &&
            getValueObject.action !== undefined &&
            getValueObject.action.type === 'method'
        "
      >
        <v-btn
          @click="methodHandler"
          :block="showOpenHelp"
          dark
          color="success"
        >
          <v-icon small left>fa-plus</v-icon>Créer
        </v-btn>
      </v-col>
      <v-col
        cols="12"
        :sm="showOpenHelp === true ? '6' : '12'"
        v-if="
          getValueObject &&
            getValueObject.action !== undefined &&
            getValueObject.action.type === 'component'
        "
      >
        <component :is="getValueObject.action.value" helper></component>
      </v-col>
      <v-col cols="12" sm="6" v-if="showOpenHelp === true">
        <v-btn
          :to="{ name: 'HelperIndex', params: { value: this.value } }"
          color="info"
          block
        >
          <v-icon small left>fa-question</v-icon>Ouvrir l'aide
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { api } from "@/api";
import { SalesAdder } from "@/modules/Ventes/components";
import {
  DefaultDailyPrepSlipEditor,
  AutomaticPrepSlipEditor,
  ScheduledPrepEditor
} from "@/modules/PreparationSlip/components";
import {
  InventoryWasteDialog,
  ProductionDialog
} from "@/modules/Inventory/components";
import { UserAdminLogin } from "@/modules/UserSettings/components";
import { CustomUnitAdder } from "@/modules/CustomUnit/components";
import { ReportSender } from "@/modules/InventoryTransactionNotification/components";
import { mapGetters } from "vuex";
export default {
  name: "HelperMenuResult",
  components: {
    SalesAdder,
    AutomaticPrepSlipEditor,
    DefaultDailyPrepSlipEditor,
    ScheduledPrepEditor,
    InventoryWasteDialog,
    ProductionDialog,
    CustomUnitAdder,
    ReportSender,
    UserAdminLogin
  },
  props: {
    value: {
      required: true
    },
    showOpenHelp: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters(["getHelperTopics"]),
    getValueObject() {
      return this.getHelperTopics.find(x => x.value === this.value);
    }
  },
  methods: {
    openHelperHandler() {},
    methodHandler() {
      switch (this.getValueObject.action.value) {
        case "createRecipe":
          this.createRecipe();
          break;
        case "createWasteCause":
          this.createWasteCause();
          break;
      }
    },
    async createRecipe() {
      let recipeName = await this.$dialog.prompt({
        text: "",
        title: "Nom de la recette"
      });
      if (recipeName) {
        const data = {
          organisation: this.getOrganisationId,
          nom: recipeName,
          est_intermediaire: true,
          data: {
            store: this.getStoreId,
            use_conversion_formula: false
          }
        };
        try {
          this.$store.dispatch("startLoadingOverlay");
          const res = await api.postRecipe(data);
          this.$router.push({
            name: "RecipeEditor",
            params: { id: res.id }
          });
        } finally {
          this.$store.dispatch("endLoadingOverlay");
        }
      }
    },
    async createWasteCause() {
      let name = await this.$dialog.prompt({
        text: "Inscrire le nom de la nouvelle cause",
        title: "Nouvelle cause de perte"
      });
      if (name) {
        const data = {
          name: name,
          store: this.getStoreId
        };
        try {
          this.$store.dispatch("slo");
          await this.$store.dispatch("addWasteCause", data);
        } finally {
          this.$store.dispatch("elo");
        }
      }
    }
  }
};
</script>

<style></style>
